import React from 'react';
import './App.scss';
import Navbar from './components/Navbar';
import Homepage from './screens/Homepage';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Homepage />
    </div>
  );
}

export default App;
